import axios from 'axios';
import { getCookie } from './cookie';
class Api {
    requester;
    constructor() {
        this.requester = axios.create();
        // Request Interceptor
        this.requester.interceptors.request.use((request) => {
            request.baseURL = process.env.APP_API_SERVER;
            const lang = getCookie(process.env.APP_LANG_KEY);
            const userToken = getCookie(process.env.APP_USER_TOKEN_KEY);
            if (lang)
                request.headers['Content-Language'] = lang;
            if (userToken)
                request.headers['Authorization'] = `Bearer ${userToken}`;
            return request;
        });
        // Response Interceptor
        this.requester.interceptors.response.use((response) => response.data, (error) => Promise.reject(error.response));
    }
    // GET request
    async get({ url, lang, params = {}, userToken }) {
        const serializedParams = Api.serializeParams(new Map(Object.entries(params)));
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        if (lang)
            options.headers['Content-Language'] = lang;
        if (userToken)
            options.headers.Authorization = `Bearer ${userToken}`;
        return await this.request(`${url}?${serializedParams}`, options);
    }
    // POST request
    async post(resource, params = {}, lang, contentType) {
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': contentType || 'application/json',
            },
            data: params,
        };
        if (lang)
            options.headers['Content-Language'] = lang;
        return await this.request(resource, options);
    }
    // PUT request
    async put(resource, params = {}, lang, contentType) {
        const options = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': contentType || 'application/json',
            },
            data: params,
        };
        if (lang)
            options.headers['Content-Language'] = lang;
        return await this.request(resource, options);
    }
    // DELETE request
    async delete(resource, params = {}) {
        const options = {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            data: params,
        };
        return await this.request(resource, options);
    }
    // Axios request
    async request(url, options) {
        return this.requester(url, options);
    }
    // Utility function to serialize parameters
    static serializeParams(params) {
        const array = [];
        params.forEach((value, key) => {
            array.push(`${key}=${encodeURIComponent(value)}`);
        });
        return array.join('&');
    }
}
export default new Api();
//# sourceMappingURL=api.js.map